// Convex API typed-binding shim.
//
// The consent UI is a separate npm project from the admin Convex backend, so
// it can't directly import the auto-generated `_generated/api`. We use the
// Convex `anyApi` helper for runtime calls and define thin TypeScript
// interfaces here that document the public OAuth surface for type-checking.
//
// To upgrade to full type-safety later: copy the auto-generated
// `_generated/api.d.ts` from `CCL Acquisitions Dashboard/convex/_generated/`
// into `cloudflare_consent/src/_generated/` and re-export from here.

import { anyApi } from "convex/server";

// ---- Public OAuth surface types ----------------------------------

export type GetMyEntitlementsResponse = {
  allowed_scopes: string[];
  role: "admin" | "user" | "worker" | null;
  name: string | null;
  display_title?: string | null;
  enabled: boolean;
  reason?: string;
};

export type CreateAuthCodeArgs = {
  clientId: string;
  redirectUri: string;
  scope: string[];
  codeChallenge: string;
  codeChallengeMethod: "S256";
  state?: string;
};

export type CreateAuthCodeResponse = {
  code: string;
  state?: string;
};

export type ListMyClientsEntry = {
  clientId: string;
  clientName?: string | null;
  issuedAt: number;
  lastUsedAt?: number | null;
  activeTokenCount: number;
  scope?: string[];
};

// ---- API binding -------------------------------------------------

export const api = anyApi as unknown as {
  oauth: {
    createAuthCode: any;
    getMyEntitlements: any;
    listMyClients: any;
    revokeMyClient: any;
  };
};
